@if (breadcrumbs().length) {
<nav class="breadcrumb-custom__nav" aria-label="Breadcrumb" role="navigation">
  <ol
    class="breadcrumb-custom__nav-list"
    itemscope
    itemtype="https://schema.org/BreadcrumbList"
  >
    @if(isMobile()){
    <li
      class="breadcrumb-custom__item breadcrumb-custom__item--mobile"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <span
        class="breadcrumb-custom__chevron pi pi-angle-left"
        aria-hidden="true"
      ></span>
      <a
        class="breadcrumb-custom__item-link"
        itemprop="item"
        [href]="breadcrumbs()[breadcrumbs().length - 1].routerLink"
        [attr.aria-label]="breadcrumbs()[breadcrumbs().length - 1].label"
      >
        <span itemprop="name">{{
          breadcrumbs()[breadcrumbs().length - 1].label
        }}</span>
      </a>
      <meta itemprop="position" [attr.content]="1" />
    </li>
    } @else { @for(breadcrumb of breadcrumbs(); track breadcrumb; let i =
    $index){
    <li
      class="breadcrumb-custom__item"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
    >
      <a
        class="breadcrumb-custom__item-link"
        itemprop="item"
        [href]="breadcrumb.routerLink"
        [attr.aria-label]="breadcrumb.label"
      >
        <span itemprop="name">{{ breadcrumb.label }}</span>
      </a>
      <meta itemprop="position" [attr.content]="i + 1" />
    </li>
    } @if(currentPage()){
    <li
      class="breadcrumb-custom__item"
      itemprop="itemListElement"
      itemscope
      itemtype="https://schema.org/ListItem"
      aria-current="page"
    >
      <span class="breadcrumb-custom__current" itemprop="name">{{
        currentPage()
      }}</span>

      <meta itemprop="position" [attr.content]="breadcrumbs().length + 1" />
    </li>
    } }
  </ol>
</nav>
}
